// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Typewriter {\n  display: inline;\n}\n\n.form {\n  aspect-ratio: 16 / 9;\n}\n", "",{"version":3,"sources":["webpack://./src/components/pages/Experimental/Experimental.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".Typewriter {\n  display: inline;\n}\n\n.form {\n  aspect-ratio: 16 / 9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
